import { connect } from 'react-redux';
import { Table } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';

import { statementStatuses } from '../../../helpers/constants/statementStatuses';
import { getStatusColor } from './IncomeStatement';
import { formatTransactiontDate } from '../../../helpers/date/date';
import { UserWithdrawalStatus } from '../../../helpers/constants/payment';
import { fetchWithDrawalsStart } from '../../../store/actions/WithDrawAction';
import { updatePayoutInfo, initiateTablePayoutStart } from '../../../store/actions/PayoutAction';

import NothingHere from '../../../images_new/icon/nothing_here.svg?react';

const WithdrawalRequest = (props) => {
  const { withDrawals } = props;
  const [loadingStates, setLoadingStates] = useState({});
  const payoutDetails = useSelector((state) => state?.payoutModel?.authentication?.loading);

  useEffect(() => {
    props.dispatch(fetchWithDrawalsStart());
  }, []);

  const handleWithdraw = async (data) => {
    if (
      data.status == UserWithdrawalStatus.APPROVE_BY_ADMIN ||
      data.status == UserWithdrawalStatus.REFERRAL_AUTO_APPROVED
    ) {
      // Set loading state for this specific withdrawal request
      setLoadingStates((prev) => ({ ...prev, [data.user_withdrawal_unique_id]: true }));
      props.dispatch(updatePayoutInfo({ amount: data.requested_amount }));
      props.dispatch(initiateTablePayoutStart(data.user_withdrawal_unique_id));
    }
  };

  useEffect(() => {
    // When payoutDetails changes, clear all loading states
    if (!payoutDetails) {
      setLoadingStates({});
    }
  }, [payoutDetails]);

  const isAnyRowLoading = () => Object.values(loadingStates).some((loading) => loading);

  const isRowLoading = (withdrawalRequest) =>
    loadingStates[withdrawalRequest.user_withdrawal_unique_id];

  const canWithdraw = (status) =>
    status == UserWithdrawalStatus.APPROVE_BY_ADMIN ||
    status == UserWithdrawalStatus.REFERRAL_AUTO_APPROVED;

  return (
    <div>
      <div className='security statement'>
        <div className='trans-table-sec'>
          <div className='trans-table'>
            <Table bordered={false} borderless={true} responsive>
              <thead>
                <tr>
                  <th>DATE & TIME</th>
                  <th>INVOICE</th>
                  <th>PAYOUT AMOUNT</th>
                  <th>STATUS</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              {withDrawals && withDrawals.length ? (
                <tbody>
                  {withDrawals.map((withdrawalRequest) => (
                    <tr
                      key={withdrawalRequest.user_withdrawal_unique_id}
                      onClick={() => handleWithdraw(withdrawalRequest)}
                    >
                      <td>{formatTransactiontDate(withdrawalRequest.created)}</td>
                      <td> {withdrawalRequest.user_withdrawal_unique_id} </td>
                      <td> {withdrawalRequest.requested_amount_formatted} </td>
                      <td
                        className={`hidden-xs status-text status-text-${getStatusColor(
                          statementStatuses[withdrawalRequest.status],
                        )}`}
                      >
                        {' '}
                        {statementStatuses[withdrawalRequest.status]}{' '}
                      </td>
                      <td>
                        {canWithdraw(withdrawalRequest.status) && (
                          <button
                            className='action_withdrawal_button'
                            onClick={(e) => {
                              e.stopPropagation();
                              handleWithdraw(withdrawalRequest);
                            }}
                            disabled={isRowLoading(withdrawalRequest) || isAnyRowLoading()}
                            title='withdraw'
                          >
                            {isRowLoading(withdrawalRequest) ? 'Loading ...' : 'Withdraw'}
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td colSpan={4}>
                      <div className='mt-3 nothing_here'>
                        <NothingHere />
                      </div>
                    </td>
                  </tr>
                </tbody>
              )}
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToPros = (state) => ({
  userData: state.users,
  withDrawals: state.withDraw.withDrawals.data.history,
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(WithdrawalRequest);
